import Vue from "vue";
//scripts gerados a partir dos gerados pelo webChats, consultar
const lang = Vue.prototype.$lang_.getLang().title || "pt";
let imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
if (lang === "es") {
    imgSrc = require("@/assets/images/sacDesktop-es-ES.png");
} else if (lang === "en") {
    imgSrc = require("@/assets/images/sacDesktop-en-US.png");
} else {
    imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
}

const mobile = require("@/assets/images/sacMobile.png");
export const deskManager = {
    openedBy: null,

    dwhatToggle(source) {
        if (this.openedBy && this.openedBy !== source) {
            return;
        }

        const chatIcon = document.getElementById("dwhats");
        let chatWindow = document.getElementById("dwhatDiv");

        if (chatWindow == null) {

            chatWindow = document.createElement("div");
            chatWindow.id = "dwhatDiv";
            chatWindow.style = "border-radius: 8px; position: fixed; border: 1px solid #ccc; width: 400px; bottom: 148px; height: 500px; right: 10px; max-width: 94%; z-index: 99 !important; background: white; overflow: hidden;";

            const chatIframe = document.createElement("iframe");
            const dataChanelId = "cc3ee296-a62e-4b49-9d21-f72f0bbd786f";

            chatIframe.src = "https://agents.imply.com.br/chat/" + dataChanelId;
            chatIframe.style = "width: 100%; height: 100%;";
            
            chatWindow.appendChild(chatIframe);
            document.body.appendChild(chatWindow);

            chatIcon.classList.remove("dwhatO");
            chatIcon.classList.add("dwhatC");
            this.openedBy = source;
        } else if (chatWindow.style.display === "none") {
            chatWindow.style.display = "block";
            chatIcon.classList.remove("dwhatO");
            chatIcon.classList.add("dwhatC");
            this.openedBy = source;
        } else {
            chatWindow.style.display = "none";
            chatIcon.classList.add("dwhatO");
            chatIcon.classList.remove("dwhatC");
            this.openedBy = null;
        }
    },
    dwhatLoad() {
        var e = document.createElement("style");
        (e.innerHTML = `.dwhatC::before{background:url(${imgSrc})top center no-repeat;background-size: cover;}.dwhatO::before{background:url(${imgSrc})top 
			center no-repeat;background-size: cover;}#dwhats{width:168px;height:106px;display:block;cursor: pointer;}
            @media(max-width:958px){#dwhats{width:120px;height: 120px;}.dwhatO::before{background:url(${mobile})top 
			center no-repeat;background-size: cover;}.dwhatC::before{background:url(${mobile})top center no-repeat;background-size: cover;}}
            #dwhats{position:fixed;bottom:48px;z-index:10;display:flex;align-items:center;right:15px;}
			#dwhats::before{content:\"\";width:100%;height:100%;display: block;}`),
            document.head.appendChild(e);
        let link = document.createElement("a");
        link.addEventListener("click", () => {
            this.dwhatToggle('icon');
        });
        (link.id = "dwhats"),
            (link.className = "dwhatO"),
            link.classList.add("animate__animated", "animate__fadeInUp");
        document.body.appendChild(link);
    },
};
